import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { transformFileSize } from '@mining/ui/core/util';
import { IMIconType, IMProgressStatus, IMStatus } from './typings';

@Component({
  selector: 'm-file-display-item',
  template: `
    <div class="m-file-display-item" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
      <div class="m-file-display-item-content">
        <div class="m-file-display-item-name">
          <label
            *ngIf="mShowCheckBox"
            nz-checkbox
            [(ngModel)]="mChecked"
            (ngModelChange)="mCheckedChange.emit({ uid: mUid, checked: $event })"
          ></label>
          <span>{{ mName }}</span>
        </div>
        <div class="m-file-display-item-size">{{ sizeValue }}</div>
        <div class="m-file-display-item-icon-container" *ngIf="!mEditable">
          <m-file-display-icon
            class="m-file-display-item-icon-edit"
            *ngIf="iconType === 'encryption'"
            [mType]="'edit'"
            (click)="editChange(true)"
          ></m-file-display-icon>
          <m-file-display-icon class="m-file-display-item-icon-type" *ngIf="iconType" [mType]="iconType"></m-file-display-icon>
          <m-file-display-icon
            class="m-file-display-item-icon-close"
            [mType]="'close'"
            (click)="mDeleteItem.emit(mUid)"
          ></m-file-display-icon>
        </div>
        <div class="m-file-display-item-edit" *ngIf="mEditable">
          <input
            nz-input
            placeholder="请输入密码"
            type="password"
            [ngClass]="{ 'm-file-display-item-edit-mismatch': mMismatch }"
            [(ngModel)]="password"
          />
          <div class="m-file-display-item-edit-operations">
            <a (click)="mSubmit.emit({ uid: mUid, password: password })">提交</a>
            <a (click)="cancel()">取消</a>
          </div>
        </div>
      </div>
      <nz-progress
        class="m-file-display-item-progress"
        [nzPercent]="mPercent"
        [nzStrokeWidth]="1"
        [nzStatus]="progressStatus"
        [nzShowInfo]="false"
        [nzStrokeColor]="strokeColor"
      ></nz-progress>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MFileItemComponent implements OnChanges {
  @Input() mName: string = '';
  @Input() mStatus: IMStatus = 'success';
  @Input() mPercent: number = 30;
  @Input() mSize: number = 0;
  @Input() mUid: string = '';
  @Input() mChecked: boolean = true;
  @Input() mEditable: boolean = false;
  @Input() mMismatch: boolean = false;
  @Input() mShowCheckBox: boolean = false;
  @Output() readonly mDeleteItem = new EventEmitter<string>();
  @Output() readonly mSubmit = new EventEmitter<{ uid: string; password: string }>();
  @Output() readonly mEditChange = new EventEmitter<{ uid: string; editable: boolean }>();
  @Output() readonly mCheckedChange = new EventEmitter<{ uid: string; checked: boolean }>();
  @Output() readonly mouseEnter = new EventEmitter<{ status: IMStatus; typeIcon: HTMLElement; closeIcon: HTMLElement }>();
  @Output() readonly mouseLeave = new EventEmitter<{ status: IMStatus; typeIcon: HTMLElement; closeIcon: HTMLElement }>();

  iconType: IMIconType | undefined = undefined;
  progressStatus!: IMProgressStatus;
  password = '';
  typeElement!: HTMLElement;
  closeElement!: HTMLElement;

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}

  get strokeColor(): string {
    return this.mStatus === 'success' || this.mStatus === 'default' ? '#f0f0f0' : '';
  }

  get sizeValue(): string {
    return transformFileSize(this.mSize);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { mStatus } = changes;
    if (mStatus) {
      switch (mStatus.currentValue as IMStatus) {
        case 'success':
          this.iconType = 'success';
          this.progressStatus = 'success';
          break;
        case 'exception':
          this.iconType = 'exception';
          this.progressStatus = 'exception';
          break;
        case 'encryption':
          this.iconType = 'encryption';
          this.progressStatus = 'exception';
          break;
        case 'default':
          this.iconType = undefined;
          this.progressStatus = 'normal';
          break;
        case 'processing':
          this.iconType = undefined;
          this.progressStatus = 'active';
          break;
      }
    }
  }

  editChange(editable: boolean): void {
    this.mEditChange.emit({ uid: this.mUid, editable });
  }

  cancel(): void {
    this.password = '';
    this.editChange(false);
  }

  onMouseEnter(): void {
    this.closeElement = this.elementRef.nativeElement.querySelector('.m-file-display-item-icon-close');
    this.typeElement = this.elementRef.nativeElement.querySelector('.m-file-display-item-icon-type');
    if (this.closeElement || this.typeElement) {
      this.mouseEnter.emit({ status: this.mStatus, typeIcon: this.typeElement, closeIcon: this.closeElement });
    }
  }

  onMouseLeave(): void {
    if (this.closeElement || this.typeElement) {
      this.mouseLeave.emit({ status: this.mStatus, typeIcon: this.typeElement, closeIcon: this.closeElement });
    }
  }

  markForCheck(): void {
    this.cdr.markForCheck();
  }
}
